<template>
  <div class='app'>
    <router-view/>
  </div>
</template>

<script>

export default {
    name: "app"
};

</script>

<style scoped>
  .app {
    position: relative
  }

</style>
